import React, { useState } from 'react';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <a href="/" className="logo">
          <img src={`${process.env.PUBLIC_URL}/logo-spiegelei.png`} alt="Spiegelei Studio Logo" className="logo-image" />
          <div className="logo-text">
            <span className="logo-name">Spiegelei Studio</span>
            <span className="tagline">Independent App Studio</span>
          </div>
        </a>
        {/* 法律页面也用这个页头，所以锚点都带上 / */}
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <a href="/#apps">Apps</a>
          <a href="/#billing">Pricing &amp; Billing</a>
          <a href="/imprint">Imprint</a>
        </nav>
        <button
          className="menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
